module.exports = __webpack_public_path__ + "static/media/arrow_left.59607dc5.svg";